<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">Tepatasi: Le Au’alumā</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_004#id_Toc159854090">Book One</a>
<ul>
<li><a href="#/index_split_005#id_Toc159854091">I. 1905</a></li>
<li><span href="#/index_split_006#id_Toc159854092" title="Link target outside of Sample">II. 1910</span></li>
</ul>
</li>
<li><span href="#/index_split_007#id_Toc159854093" title="Link target outside of Sample">Book Two</span>
<ul>
<li><span href="#/index_split_008#id_Toc159854094" title="Link target outside of Sample">I. July 1917</span></li>
<li><span href="#/index_split_009#id_Toc159854095" title="Link target outside of Sample">II. Summer 1917</span></li>
<li><span href="#/index_split_010#id_Toc159854096" title="Link target outside of Sample">III. April 1918</span></li>
<li><span href="#/index_split_011#id_Toc159854097" title="Link target outside of Sample">IV. September 1918</span></li>
<li><span href="#/index_split_012#id_Toc159854098" title="Link target outside of Sample">V. November 1918</span></li>
<li><span href="#/index_split_013#id_Toc159854099" title="Link target outside of Sample">VI. 1919</span></li>
<li><span href="#/index_split_014#id_Toc159854100" title="Link target outside of Sample">VII. Spring 1919</span></li>
<li><span href="#/index_split_015#id_Toc159854101" title="Link target outside of Sample">VIII. December 1919</span></li>
</ul>
</li>
<li><span href="#/index_split_016#id_Toc159854102" title="Link target outside of Sample">Book Three</span>
<ul>
<li><span href="#/index_split_017#id_Toc159854103" title="Link target outside of Sample">I. 1921</span></li>
</ul>
</li>
<li><span href="#/index_split_018#id_Toc159854104" title="Link target outside of Sample">Dedication</span></li>
<li><span href="#/index_split_019#id_Toc159854105" title="Link target outside of Sample">Acknowledgements</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7c0cc282